import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { toLocalNumberFormat } from '../../utils/toLocalNumberFormat.js';
import { Text } from '../Text/Text.js';
export const FormatValue = JSX(({ value, fractionDigits, fixed, prefix, postfix }) => (_jsx(Text, { size: "text-h3", children: typeof value === 'number'
        ? [prefix, toLocalNumberFormat(fractionDigits, { fixed })(value), postfix]
            .filter(Boolean)
            .join(' ')
        : value })));
//# sourceMappingURL=FormatedValue.js.map